import { render, staticRenderFns } from "./Pertanyaan.vue?vue&type=template&id=2fe45d9e&scoped=true"
import script from "./Pertanyaan.vue?vue&type=script&lang=js"
export * from "./Pertanyaan.vue?vue&type=script&lang=js"
import style0 from "./Pertanyaan.vue?vue&type=style&index=0&id=2fe45d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe45d9e",
  null
  
)

export default component.exports